import {Component, OnInit} from "@angular/core";

@Component({
    selector: "acceptable-use-policy",
    templateUrl: "./acceptable-use-policy.component.html",
    styleUrls: ["./acceptable-use-policy.component.scss"],
    standalone: false
})
export class AcceptableUsePolicyComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}
